import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getReferralPointUser = createAsyncThunk('referralPoint/getReferralPointUser', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/referral-point/user/${id}`);
    const data = await response.data;
    return data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
